import React from "react";
import {Table} from "reactstrap";
import {formatPrice} from "tunnel-commande/src/components/mon-compte/MonCompteAction";
import { withTranslation} from 'react-i18next';
import {getShopInfosInStorage} from "tunnel-commande/src/components/cart/ShopInfos";

interface PriceTableState {
  surfaceSelected: number;
  qtySelected: number;
}

interface PriceTableProps {
  data: any;
  dimensions: any;
  quantite: number;
}
class PriceTable extends  React.Component<any, PriceTableState> {
  private readonly qtyMin: number = 0;
  private readonly dimensions: any = null;
  constructor(props: any) {
    super(props);
    this.qtyMin = getShopInfosInStorage() && getShopInfosInStorage().quantiteMin ?  getShopInfosInStorage().quantiteMin : 0;
    this.dimensions = getShopInfosInStorage() ?  getShopInfosInStorage().dimensionsVisuel : {};

    this.state = {
      surfaceSelected: 0,
      qtySelected: 0,
    };
  }

  componentDidUpdate(prevProps: Readonly<PriceTableProps>, prevState: Readonly<PriceTableState>, snapshot?: any) {
    if(prevProps !== this.props) {
      let newSurface = this.state.surfaceSelected;
      let newQty = this.state.qtySelected;
      if(this.props.quantite !== this.state.qtySelected) {
        newQty = Number(this.props.quantite);
      }
      const newSurfaceSelected = Math.round(this.props.dimensions.l * this.props.dimensions.h * 100) /100;
      if(newSurfaceSelected && newSurfaceSelected > 0 && newSurfaceSelected !== this.state.surfaceSelected) {
        newSurface = newSurfaceSelected;
      }
      if(newSurface !== this.state.surfaceSelected || newQty !== this.state.qtySelected) {
        this.setState({ surfaceSelected: newSurface, qtySelected: newQty});
      }
    }
  }

  private reduceData(data : any) {
    const filteredData = {...data};
    const surfaceMax = this.dimensions.centimetreMaxLargeur * this.dimensions.centimetreMaxHauteur;

    Object.keys(filteredData).map((surface: any, index: number) => {
      if(parseInt(surface)> surfaceMax) {
        delete filteredData[surface];
      } else {
        Object.keys(filteredData[surface]).map((qte: any, index2: number) => {
          if (qte < this.qtyMin) {
            delete filteredData[surface][qte];
          }
        });
      }
    });

    return filteredData;
  }

  private getNextSurface(object:any, value: any) {
    const index = Object.keys(object).indexOf(value);
    const strNextSurface = this.props.data && Object.keys(this.props.data)[index+1] ? Object.keys(this.props.data)[index+1] : null ;
    return strNextSurface;
  }

  render() {
    if(!this.props.data) return false;

    let selected = {quantite: 0, surface: 0};
    const data = {...this.props.data};
    const dataFiltered = this.reduceData(data);

    for(const surface of Object.keys(dataFiltered).reverse()) {
      if(this.state.surfaceSelected >= Number(surface)) {
        for(const quantite of Object.keys(dataFiltered[surface]).reverse()) {
          if(this.state.qtySelected >= Number(quantite)) {
            selected = {quantite: Number(quantite), surface: Number(surface)};
            break;
          }
        }

        break;
      }
    }

    const exempleSurface = (surface:string) => {
      const result:  string[] =  [];
      const exemples = {
        '21' : '5 x 4cm',
        '51': '10 x 5cm',
        '121' : '20 x 6cm',
        '251' : '25 x 10cm',
        '551' : '25 x 22cm',
        '1151' : '40 x 28,75cm'
      };
      for (const [key, value] of Object.entries(exemples)) {
        if(key === surface) {
          result.push(`Exemple : ${value}`);
        }
      }
      return result;
    }

    const items = Object.keys(dataFiltered).map((surface: any, indexSurface: number) => {
      const strNextSurface = this.getNextSurface(this.props.data,surface) ;
      const tds = Object.keys(dataFiltered[surface]).map((qte: any, index: number) => {
        const style = (selected.surface == surface && selected.quantite == qte && this.props.simulatePrice) ? {boxShadow: 'inset 0px 0px 0px 2px #f00'} : {};
        const priceCell = `${formatPrice(dataFiltered[surface][qte].toFixed(2).toString())}€`;
        return <td style={style} className={'align-middle'} key={index}>{priceCell}</td>;
      });
      tds.unshift(
        <td key={surface}>
          <div className={'bold black'}>
            <span className={'font-italic'}>
              {this.props.t('less_than')}&nbsp;
            </span>
            {strNextSurface} cm²
          </div>
          {strNextSurface &&
            <div className={'font12'}>
              {exempleSurface(strNextSurface)}
            </div>
          }
        </td>);

      return <tr key={surface}>{tds}</tr>;
    });

    const qtes: string[] = dataFiltered[Object.keys(dataFiltered)[0]];
    const ths: JSX.Element[] = Object.keys(qtes).map((qte: string, index: number) => {
      const nextQty = Object.keys(qtes)[index+1] ? `${this.props.t('to')} ${parseInt(Object.keys(qtes)[index+1]) -1}` : '+' ;
      return <th key={index}>{qte} {nextQty}</th>;
    });

    return (
      <Table className={'tablePrices bg-white mb-0'} bordered={true} striped={true}>
        <thead style={{backgroundColor: "black", color: "white"}}>
          <tr>
            <th className={'p-0 m-0'}>
              <div className={'priceListFirstThContainer'}>
              <div className={'text-right'}> {this.props.t('quantity')}</div>
              <div className={"priceListFirstThContainerArea"}>{this.props.t('area')}</div>
              <div className={'priceListFirstTh'}></div>
              </div>
            </th>
            {ths}
          </tr>
        </thead>
        <tbody>
          {items}
        </tbody>
      </Table>
    );
  }
}
export default withTranslation('common')(PriceTable);
